<script setup lang="ts">
import {DataTable} from 'primevue';
import {computed, getCurrentInstance, useSlots} from 'vue';

const slots = useSlots();
const instance = getCurrentInstance();
const hasRowClick = computed((): boolean => !!instance?.vnode.props?.onRowClick);
const rowClass = computed((): string => hasRowClick.value ? 'aeg-datatable-clickable-row' : '');

</script>

<template>
<DataTable
    v-bind="$attrs"
    stripedRows
    tableStyle="min-width: 0px"
    :row-class="() => rowClass"
    :row-hover="hasRowClick"
>
    <template v-for="(_, slotName) in slots" :key="slotName" #[slotName]="slotProps">
        <slot :name="slotName" v-bind="slotProps || {}" />
    </template>
    <template #loading>
        <aeg-loader message="" />
    </template>
</DataTable>
</template>

<style scoped lang="scss">

</style>
